module.exports = __webpack_public_path__ + "static/media/customers.042cd7e6.svg";